<template>
  <header class="header-container">
    <nav class="nav-container">
      <img class="logo-nav desktop" src="@/assets/logo.png" alt="logo" />
      <ul>
        <li>
          <router-link class="nav-link" to="/" @click.native="changeMobileNav('home')">
            <span
              class="material-icons mobile"
              :class="[isMobileNavActive == 'home' ? 'active' : '']"
            >home</span>
            <p class="link-text" :class="[isMobileNavActive == 'home' ? 'active' : '']">Beranda</p>
          </router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/program" @click.native="changeMobileNav('program')">
            <span
              class="material-icons mobile"
              :class="[isMobileNavActive == 'program' ? 'active' : '']"
            >work</span>
            <p class="link-text" :class="[isMobileNavActive == 'program' ? 'active' : '']">Program</p>
          </router-link>
        </li>
        <li>
          <router-link class="nav-link" to="/about" @click.native="changeMobileNav('about')">
            <span
              class="material-icons mobile"
              :class="[isMobileNavActive == 'about' ? 'active' : '']"
            >people</span>
            <p class="link-text" :class="[isMobileNavActive == 'about' ? 'active' : '']">About</p>
          </router-link>
        </li>
        <li class="mobile">
          <div class="nav-link" @click="dropdownActive">
            <span class="material-icons mobile" :class="{ active: isDropdownActive }">face</span>
          </div>
        </li>
      </ul>
    </nav>
    <div class="right-header">
      <div data-cy="profile" class="profile desktop" @click="dropdownActive">
        <span class="material-icons">face</span>
        <p id="username">{{ getUsername }}</p>
        <span class="material-icons">arrow_drop_down</span>
      </div>
      <div class="profile-container" v-if="isDropdownActive">
        <ul class="nav-profile">
          <li
            class="nav-profile-link"
            v-if="
              getHasProgramRegistered && 
              getUserRole[getUserRole.length - 1].role_id == userRole.STUDENT &&
              getStudentTermStatus != termStatus.TERM_BREAK && 
              (getStudentTermStatus == termStatus.CONTINUE || getIsPassed) &&
              getPaymentStatus == paymentState.ACCEPTED
            "
            @click="changeMobileNav('jadwal')"
          >
            <router-link to="/student-schedule" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">today</span>
              Jadwal
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="getUserRole[0].role_id == userRole.TEACHER"
            @click="changeMobileNav('jadwal')"
          >
            <router-link to="/teacher-schedule" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">today</span>
              Jadwal
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="
              getHasProgramRegistered && 
              getUserRole[getUserRole.length - 1].role_id == userRole.STUDENT && 
              getStudentTermStatus != termStatus.TERM_BREAK && 
              (getIsPassed || getStudentTermStatus == termStatus.CONTINUE)
            "
            @click="changeMobileNav('pembayaran')"
          >
            <router-link to="/transaction" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">monetization_on</span>
              Pembayaran
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="
            (
              getHasProgramRegistered &&
              getUserRole[getUserRole.length - 1].role_id == userRole.STUDENT
            ) || 
            (
              getStudentTermStatus == termStatus.TERM_BREAK || 
              getStudentTermStatus == termStatus.CONTINUE
            )"
            @click="changeMobileNav('laporan')"
          >
            <router-link to="/student-report" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">trending_up</span>
              Laporan
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="getUserRole[getUserRole.length - 1].role_id == userRole.STUDENT_SELECTOR"
            @click="changeMobileNav('laporan')"
          >
            <router-link to="/teacher-report" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">trending_up</span>
              Laporan
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="
            getHasProgramRegistered && 
            getStudentTermStatus != termStatus.TERM_BREAK && 
            getStudentTermStatus != termStatus.CONTINUE"
            @click="changeMobileNav('pengumuman')"
          >
            <router-link to="/announcement" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">description</span>
              Pengumuman
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="getHasProgramRegistered"
            @click="changeMobileNav('data registrasi')"
          >
            <div @click="$bvModal.show('registration-data')" class="link">
              <span class="material-icons mobile">person_pin</span>
              Data Registrasi
            </div>
          </li>
          <li
            class="nav-profile-link"
            v-if="
            getUserRole[getUserRole.length -1].role_id == userRole.STUDENT && 
            getStudentTermStatus != termStatus.TERM_BREAK && 
            getReregistrationPeriodOpened"
            @click="changeMobileNav('form survey')"
          >
            <router-link to="/survey-form" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">description</span>
              Isi Form Survey
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="
            getUserRole[getUserRole.length -1].role_id == userRole.STUDENT && 
            getReregistrationPeriodOpened"
            @click="changeMobileNav('decision survey')"
          >
            <router-link to="/decision-form" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">description</span>
              Daftar Ulang
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="getStudentTermStatus == termStatus.QUIT && 
            getEndedTermId == getTermName"
            @click="changeMobileNav('download report')"
          >
            <router-link to="/download-report" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">description</span>
              Download Report
            </router-link>
          </li>
          <li
            class="nav-profile-link"
            v-if="getUserRole[getUserRole.length-1].role_id == userRole.STUDENT_SELECTOR"
            @click="changeMobileNav('data calon peserta')"
          >
            <router-link to="/data-calon-peserta" class="link" v-on:click.native="dropdownActive">
              <span class="material-icons mobile">description</span>
              Seleksi Pendaftaran
            </router-link>
          </li>
          <li class="nav-profile-link">
            <a class="link" @click="logout">
              <span class="material-icons mobile">power_settings_new</span>
              Keluar
            </a>
          </li>
        </ul>
      </div>
    </div>
    <b-modal id="registration-data" hide-footer>
      <RegistrationData :getRegistrationData="getRegistrationData" :getFullname="getFullname" />
    </b-modal>
  </header>
</template>

<script>
import store from "@/store";
import { paymentState } from "@/store/modules/Transaction";
import { mapGetters } from "vuex";
import User, { errorHandling } from "@/services/User";
import RegistrationData from "@/components/RegistrationData.vue";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  components: {
    RegistrationData
  },
  data() {
    return {
      isDropdownActive: false,
      isMobileNavActive: "home",
      paymentState: paymentState,
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  methods: {
    changeMobileNav(path) {
      this.isDropdownActive = false;
      this.isMobileNavActive = path;
    },
    logout() {
      store.commit("removeToken");
      window.location.href = "/sign/in";
    },
    async initData() {
      await store.dispatch("resetAccessToken");
      const AccessToken = this.getAccesstoken;
      await User.getInfo(process.env.VUE_APP_URL, AccessToken);
      await User.getRole(process.env.VUE_APP_URL, AccessToken);
      if (this.getUserRole[0].role_id == UserRole.STUDENT_CANDIDATE && this.getTermName != "") {
        await User.getRegistrationData(
          process.env.VUE_APP_URL,
          AccessToken,
          this.getTermName
        );
        if (this.getHasProgramRegistered) {
          if (
            this.getStudentTermStatus != TermStatus.TERM_BREAK &&
            this.getStudentTermStatus != TermStatus.CONTINUE
          ) {
            await User.getAnnouncementReport(
              process.env.VUE_APP_URL,
              AccessToken,
              this.getPeriodId
            );
          }
        }
        if (this.getIsPassed || this.getStudentTermStatus == TermStatus.CONTINUE) {
          await User.getDataPembayaran(
            process.env.VUE_APP_URL,
            AccessToken,
            this.getTermName
          ).catch(error => {
            if (this.getStudentTermStatus != TermStatus.CONTINUE) {
              errorHandling(error);
            }
          });
        }
      }
    },
    dropdownActive() {
      this.isDropdownActive = !this.isDropdownActive;
    }
  },
  computed: {
    ...mapGetters({
      getUsername: "getUsername",
      getAccesstoken: "getAccessToken",
      getUserRole: "getUserRole",
      getRefreshToken: "getRefreshToken",
      getTermName: "getTermName",
      getHasProgramRegistered: "getHasProgramRegistered",
      getPaymentStatus: "getPaymentStatus",
      getAnnouncementAvailable: "getAnnouncementAvailable",
      getPeriodId: "getPeriodId",
      getIsPassed: "getIsPassed",
      getUrlWhatsappGroup: "getUrlWhatsappGroup",
      getRegistrationData: "getRegistrationData",
      getFullname: "getFullname",
      getTermStatus: "getTermStatus",
      getStudentTermStatus: "getStudentTermStatus",
      getReregistrationPeriodOpened: "getReregistrationPeriodOpened",
      getEndedTermId: "getEndedTermId"
    })
  },
  async created() {
    store.dispatch("hideAlertError");
    await User.getLatestPeriod(process.env.VUE_APP_URL);
    await User.getPeriods(process.env.VUE_APP_URL, this.getTermName);
    if (this.getTermName != "") {
      User.getTermStatus(process.env.VUE_APP_URL, this.getAccesstoken);
    }
    if (this.getRefreshToken == null) {
      this.logout();
      return;
    }
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px) {
  .nav-link {
    width: 140px;
  }

  .mobile {
    display: none !important;
  }

  .desktop {
    display: block !important;
  }

  .header-container {
    position: fixed !important;
    z-index: 200;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 10vh !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    background: white !important;
    box-shadow: 0 4px 10px rgba($color: #aaa, $alpha: 0.1) !important;

    .nav-container {
      width: auto !important;
      position: static !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin-left: 5% !important;
      background: transparent !important;
      box-shadow: none !important;

      ul {
        list-style: none !important;
        margin: 0 !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;

        li {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;

          p.link-text {
            display: block !important;
            &.active {
              color: $white;
              background: $primary;
              padding: 5px 20px;
              border-radius: 20px;
            }
          }
        }
      }
    }

    .right-header {
      width: auto !important;
      position: static !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: center !important;
      margin-right: 5% !important;
      background: transparent !important;
      box-shadow: none !important;

      .profile {
        display: flex !important;
        align-items: center !important;
        justify-content: space-evenly !important;
        background: $primary !important;
        color: white !important;
        padding: $gap-sm-1 $gap-sm-2 !important;
        border-radius: 20px !important;
        cursor: pointer !important;

        .material-icons {
          color: inherit !important;
        }

        #username {
          margin: 0 $gap-sm-2 !important;
        }
      }

      .profile-container {
        position: absolute !important;
        background: $primary !important;
        box-shadow: 0 0 5px rgba($color: #222, $alpha: 0.1);
        border-radius: 20px !important;
        top: 50px !important;
        left: initial !important;
        width: auto !important;
        height: auto !important;
        animation: slideFadeY 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) !important;

        ul {
          list-style: none !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 !important;
          padding: 0 !important;

          li {
            width: 100% !important;
            height: 100% !important;
            display: flex !important;
            padding: $gap-sm-1 $gap-sm-2 !important;

            &:active {
              background: transparent !important;
            }

            .link {
              padding: $gap-sm-1 $gap-sm-4 !important;
              border-radius: 20px !important;
              color: white !important;
              white-space: pre;
              display: flex;
              align-items: center !important;
              justify-content: center !important;

              &:hover {
                background: white !important;
                color: $primary !important;
              }
            }
          }
        }
      }
    }
  }
}

.mobile {
  display: block;
}

.desktop {
  display: none;
}

i.material-icons:hover {
  color: $primary;
}

.material-icons.mobile {
  color: #cad3de;
  transition: color 0.5s ease;

  &.active {
    color: $black;
  }
}

.header-container {
  position: fixed;
  z-index: 200;

  .nav-container {
    height: 8vh;
    width: 100%;
    background: white;
    box-shadow: 4px 0 10px rgba($color: #aaa, $alpha: 0.1);
    position: inherit;
    z-index: 200;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      width: inherit;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      padding: 0;
      margin: 0 10%;

      .nav-link {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        p.link-text {
          display: none;
        }

        &:active {
          color: $primary;
        }
      }
    }
  }

  .right-header {
    width: 100%;
    position: inherit;
    z-index: 199;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    align-items: center;

    img {
      margin: auto;
      max-height: 80%;
    }

    .wrapper-link {
      margin-right: 5%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .profile-container {
      display: flex;
      background: white;
      box-shadow: 4px 0 10px rgba($color: #aaa, $alpha: 0.1);
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      justify-content: center;
      align-items: center;
      width: 100%;
      animation: slideUp 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);

      ul {
        width: 100%;
        list-style: none;
        display: flex;
        flex-direction: column;
        margin: $gap-sm-2 10%;
        padding: $gap-m-1 0 4rem 0;

        li {
          display: flex;
          padding: $gap-sm-2;

          .link {
            display: flex;
            width: 100%;
            height: 100%;
            align-items: center;
            color: $black;
            cursor: pointer;
          }

          .material-icons {
            margin: $gap-sm-2;
            color: $black;
          }
        }
      }
    }
  }
}
</style>
